import React, { FC } from 'react';

import PropTypes from 'prop-types';

import { BasicButton } from '@adsk/alloy-react-button';
import { RenderIconType } from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

import { TABLE_SIZES } from '../consts';
import { TableSize } from '../types';

type DensityOptionProps = {
  setSize: (size: TableSize) => void;
  size: TableSize;
  renderIcon: RenderIconType;
  currentSize: TableSize;
};

const DensityOption: FC<DensityOptionProps> = ({
  setSize,
  size,
  renderIcon,
  currentSize,
}) => {
  return (
    <BasicButton
      onClick={() => setSize(size)}
      style={[
        {
          color: size === currentSize ? theme.colors.adskBlue500 : 'inherit',
          padding: 0,
          margin: '0 0 0 18px',
          ':focus-within': {
            boxShadow: theme.halos.focus,
          },
        },
      ]}
    >
      {renderIcon({ size: 22 })}
    </BasicButton>
  );
};

DensityOption.propTypes = {
  setSize: PropTypes.func.isRequired,
  size: PropTypes.oneOf<TableSize>(Object.values(TABLE_SIZES)).isRequired,
  currentSize: PropTypes.oneOf<TableSize>(Object.values(TABLE_SIZES))
    .isRequired,
};

export default DensityOption;
